import LogManager from "./logManager";

export const SESSION_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CONNECT_FAIL: "CONNECT_FAIL",
  NOT_FOUND: "NOT_FOUND",
  ERROR: "ERROR",
};

export const SESSION_STATUS_MESSAGE = {
  END_SUCCESS: "END_SUCCESS",
  RTMS_INIT_ERROR: "RTMS_INIT_ERROR",
  RTMS_RUNTIME_ERROR: "RTMS_RUNTIME_ERROR",
};

// Whether a session statusMessage reports an RTMS init/runtime failure.
export const isRtmsError = (statusMessage) =>
  statusMessage === SESSION_STATUS_MESSAGE.RTMS_INIT_ERROR || statusMessage === SESSION_STATUS_MESSAGE.RTMS_RUNTIME_ERROR;

/**
 * Call /session api to fetches the current RTMS session status for a given meeting UUID.
 *
 * @param {string} meetingUuid - The Zoom meeting UUID.
 * @returns {Promise<{status: string, statusMessage: string|null}>} - Object containing status and statusMessage.
 */
export const fetchRtmsSessionStatus = async (meetingUuid) => {
  console.log("Calling /session API with meetingUUID:", meetingUuid);

  try {
    const response = await fetch("/session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ meetingUuid }),
    });

    const responseJson = await response.json();
    console.log("The response of /session is:", responseJson);

    const statusCode = responseJson.StatusCode;
    if (statusCode !== 200) {
      LogManager.error("Non-200 status code from /session:", statusCode);
      return { status: SESSION_STATUS.ERROR, statusMessage: null };
    }

    const payloadJsonString = JSON.parse(responseJson.Payload);
    //sample: "{\"status\":\"INACTIVE\",\"statusMessage\":\"RTMS_INIT_ERROR\",\"meetingUuid\":\"rOHSUkn3S6ySsO2PemItXA==\"}"
    console.log(
      "The session response payloadJsonString is: ",
      payloadJsonString
    );

    const sessionJson = JSON.parse(payloadJsonString);
    const sessionStatus = sessionJson.status;
    const statusMessage = sessionJson.statusMessage;
    const rtmsRequesterAlias = sessionJson.rtmsRequesterAlias;
    const rtmsRequesterName = sessionJson.rtmsRequesterName;
    const rtmsRequesterRole = sessionJson.rtmsRequesterRole;
    const rtmsStreamId = sessionJson.rtmsStreamId;
    const rtmsStartTime = sessionJson.rtmsStartTime;
    const reviewers = sessionJson.reviewers;
    const meetingAgendaActive = sessionJson.meetingAgendaActive === true;
    const meetingActionItemsActive = sessionJson.meetingActionItemsActive === true;

    console.log("Parsed sessionStatus:", sessionStatus, "statusMessage:", statusMessage, "requester info:", rtmsRequesterAlias, rtmsRequesterName, rtmsRequesterRole, "rtmsStreamId:", rtmsStreamId, "rtmsStartTime:", rtmsStartTime, "reviewers:", reviewers);

    return {
      status: sessionStatus,
      statusMessage: statusMessage,
      rtmsRequesterAlias: rtmsRequesterAlias,
      rtmsRequesterName: rtmsRequesterName,
      rtmsRequesterRole: rtmsRequesterRole,
      rtmsStreamId: rtmsStreamId,
      rtmsStartTime: rtmsStartTime,
      reviewers: reviewers,
      meetingAgendaActive: meetingAgendaActive,
      meetingActionItemsActive: meetingActionItemsActive
    };
  } catch (error) {
    LogManager.error(`Error fetching session status: ${error.name}: ${error.message}`);
    return { status: SESSION_STATUS.CONNECT_FAIL, statusMessage: null };
  }
};
